export enum VALID_TYPE {
    PWD = 'pwd',
    EMAIL = 'email',
    PHONE = 'phone'
}

export enum VALID_STEP {
    BIND = 'bind',
    BIND2 = 'bind2',
    MFA = 'mfa'
}
